import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/design-system/sections")({
  component: () => <Navigate to="/admin/design-system/sections" />,
});
